exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .mat-menu-content {\n  max-height: 45vh !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-selector-ofic-suc/selector-ofic-suc-dialog/selector-ofic-suc-dialog.component.scss
// module id = ../../../../../src/app/components/agris/common/agris-selector-ofic-suc/selector-ofic-suc-dialog/selector-ofic-suc-dialog.component.scss
// module chunks = 0